import React, { useEffect, useState } from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { ultima_hora_center } from "../../utils/api";
import { useServer } from "../../../../context/ServerContext";
import "./LastMeasurement.css";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    PopperProps={{
      modifiers: [
        { name: "preventOverflow", options: { boundary: "scrollParent" } },
        { name: "flip", options: { boundary: "scrollParent" } },
      ],
    }}
    classes={{ popper: className }}
  />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "transparent",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    boxShadow: "none",
    padding: 0,
    maxWidth: "none",
  },
}));

const TooltipCard = styled(Grid)(({ theme }) => ({
  backgroundColor: "rgba(0,0,0,0.9)",
  color: "#c3c3c3",
  borderRadius: theme.spacing(1),
  minWidth: "10vw",
  padding: "1vw",
}));

const TooltipContent = ({ online, upcoming, idioma, translate }) => {
  const t = (key, fallback) => {
    const value = typeof translate === "function" ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };
  const statusKey = online ? "online" : "offline";
  const statusLabel = t(statusKey, online ? "Online" : "Offline");

  const formattedUpcoming = upcoming
    ? new Date(upcoming).toLocaleString(idioma || "es", {
        weekday: "short",
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "--:--";

  return (
    <TooltipCard elevation={0}>
      <Grid
        container
        justifyContent="center"
        alignContent="center"
        alignItems="center"
        fontSize=".8vw"
      >
        {statusLabel} {t("next_measurement", "Next measurement")}:{" "}
        {formattedUpcoming}
      </Grid>
    </TooltipCard>
  );
};

const LastMeasurement = ({
  translate,
  idioma,
  regionSeleccionada,
  areaSeleccionada,
  centroSeleccionado,
}) => {
  const t = (key, fallback) => {
    const value = typeof translate === "function" ? translate(key) : key;
    return value && value !== key ? value : fallback;
  };
  const { servidor } = useServer();
  const [fecha, setFecha] = useState("");
  const [online, setOnline] = useState(false);
  const [upcoming, setUpcoming] = useState("");

  useEffect(() => {
    if (!regionSeleccionada || !areaSeleccionada || !centroSeleccionado) return;

    const fetchDatos = async () => {
      try {
        const centro = [
          String(regionSeleccionada),
          String(areaSeleccionada),
          String(centroSeleccionado),
        ].join("-");

        const data = await ultima_hora_center(centro, servidor);
        setFecha(data.fecha);
        setOnline(Boolean(data.online));
        setUpcoming(data.upcoming);
      } catch (error) {
        console.error("Error fetching last measurement:", error);
      }
    };

    fetchDatos();
  }, [areaSeleccionada, centroSeleccionado, regionSeleccionada, servidor]);

  const timePart =
    fecha && fecha.includes("T") ? fecha.split("T")?.[1]?.split(".")?.[0] : "--:--";

  const rawDate = fecha
    ? new Date(fecha).toLocaleDateString(idioma || "es", {
        weekday: "long",
        day: "numeric",
        month: "long",
      })
    : "";

  const capitalizedDate = rawDate
    .split(" ")
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
    .join(" ");

  return (
    <BootstrapTooltip
      title={
        <TooltipContent
          online={online}
          upcoming={upcoming}
          idioma={idioma}
          translate={translate}
        />
      }
      placement="left"
    >
      <div className="clock-container">
        <div className="last-measurement">
          <div>{t("ultima_medicion", "Last measurement")}</div>
        </div>
        <div className="main-clock">
          <div className="days-row">
            <div>{capitalizedDate}</div>
          </div>
          <div className="time-display">{timePart}</div>
        </div>
      </div>
    </BootstrapTooltip>
  );
};

export default LastMeasurement;
